import { useEffect } from 'react';

import { useInitialArticles } from '@web/newsfeed/ArticleSearch/hooks/usePageQueryCache';
import { Article } from '@web/newsfeed/types/Article';

export function useNewsfeedPage(pageId: ID, articles: Article[]) {
  const { initArticles } = useInitialArticles(pageId, articles);

  useEffect(() => {
    initArticles();
  }, [initArticles]);
}
